import { render, staticRenderFns } from "./headerbell.vue?vue&type=template&id=2556964c&scoped=true"
import script from "./headerbell.vue?vue&type=script&lang=js"
export * from "./headerbell.vue?vue&type=script&lang=js"
import style0 from "./headerbell.vue?vue&type=style&index=0&id=2556964c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2556964c",
  null
  
)

export default component.exports